import React, { useState } from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from 'moment';


export default function BasicDateTimePicker() {

    const [value, setValue] = useState("");
    // const [result, demo] = useState("");
    // demo(moment(value).format("YYYY, MM ,DD, HH:mm"));
    // console.log('valuevalue', value);
    // console.log('result??', result);


    return (

        <div>

            <div className="">
                <h3 className="font-medium text-xl text-[#3D405B] whitespace-nowrap">
                    {/* {moment(value).format("YYYY, MM ,DD, HH:mm")} */}
                    
                    {moment(new Date(value)).format("YYYY-MM-DD HH:mm")}

                    </h3>
            </div>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DateTimePicker']}>
                    <DateTimePicker label="Basic date time picker"

                        value={value}
                        onChange={(newValue) => setValue(newValue)}
                    />
                </DemoContainer>
            </LocalizationProvider>

        </div>

    );
}
